import React from "react";

const PATHS = {
  search: "M11 4a7 7 0 1 0 0 14a7 7 0 1 0 0-14M20 20l-3.5-3.5",
  wallet: "M5 6h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zM3 10h18M16 14h2",
  bag: "M6 7h12l-1 13H7zM9 7a3 3 0 0 1 6 0",
  plus: "M12 5v14M5 12h14",
  arrowRight: "M5 12h14M13 6l6 6-6 6",
  arrowLeft: "M19 12H5M11 6l-6 6 6 6",
  close: "M6 6l12 12M18 6L6 18",
  check: "M5 12l5 5L20 7",
  trash: "M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3",
  pin: "M12 21s-7-6.5-7-12a7 7 0 1 1 14 0c0 5.5-7 12-7 12zM12 9a2 2 0 1 0 0 .01",
};

const Icon = ({ name, size = 18, strokeWidth = 2, path, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    <path d={path || PATHS[name]} />
  </svg>
);

export const Star = ({ filled }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      d="M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z"
      fill={filled ? "var(--star)" : "#dce3de"}
    />
  </svg>
);

export const Rating = ({ value }) => (
  <span className="rating" role="img" aria-label={`Rated ${value} out of 5`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} filled={i <= value} />
    ))}
  </span>
);

export default Icon;
